var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1139_89987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.62503 4.51219C8.68057 2.61865 9.20834 1.67188 9.9974 1.67188C10.7864 1.67187 11.3142 2.61865 12.3698 4.51219L12.6428 5.00207C12.9428 5.54015 13.0928 5.8092 13.3266 5.98671C13.5605 6.16423 13.8517 6.23013 14.4342 6.36191L14.9644 6.4819C17.0142 6.94567 18.039 7.17756 18.2829 7.96165C18.5267 8.74574 17.828 9.56277 16.4306 11.1968L16.0691 11.6196C15.672 12.0839 15.4735 12.3161 15.3842 12.6033C15.2949 12.8905 15.3249 13.2003 15.3849 13.8198L15.4396 14.3839C15.6508 16.564 15.7565 17.6541 15.1181 18.1387C14.4797 18.6233 13.5202 18.1815 11.601 17.2979L11.1045 17.0692C10.5591 16.8181 10.2864 16.6926 9.9974 16.6926C9.70835 16.6926 9.43567 16.8181 8.8903 17.0692L8.39379 17.2978C6.47462 18.1815 5.51504 18.6233 4.87669 18.1387C4.23833 17.6541 4.34396 16.564 4.55523 14.3839L4.60988 13.8198C4.66992 13.2003 4.69993 12.8905 4.61061 12.6033C4.5213 12.3161 4.32275 12.0839 3.92566 11.6196L3.56414 11.1968C2.16677 9.56277 1.46808 8.74574 1.71191 7.96165C1.95574 7.17756 2.98061 6.94567 5.03034 6.4819L5.56063 6.36192C6.1431 6.23013 6.43434 6.16423 6.66818 5.98671C6.90202 5.8092 7.052 5.54015 7.35195 5.00207L7.62503 4.51219Z",
    stroke: "#8F91A1",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1139_89987"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.eada6642225ab5991f62cb94022121bb.svg";
export { ForwardRef as ReactComponent };